import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  hide = true;

  form: FormGroup;
  public loginInvalid: boolean;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService
  ) {
  }

  async ngOnInit() {
    this.form = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  async onSubmit() {
    this.loginInvalid = false;
    if (this.form.valid) {
      const username = this.form.get('username').value;
      const password = this.form.get('password').value;
      //this.router.navigate(['/dashboard']);
      this.authService.login(username, password, async (status, data) => {
        if (status) {
            this.router.navigate(['/dashboard']);
        } else {
          if (data.error.passwordReset == true) {
            let newPassword = "";
            await Swal.fire({
              title: 'Cambio Password',
              input: 'text',
              inputLabel: 'Nuova Password',
              inputValue: '',
              showCancelButton: true,
              inputValidator: (value) => {
                if (!value) {
                  return null;
                } else {
                  newPassword = value;
                }
              }
            })
            
            if (newPassword == null || newPassword == "") {
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Devi inserire la nuova password'
              });
            } else {
              this.authService.resetPassword(username, password, async (status, data) => {
                if (status) {
                  this.authService.login(username, password, async (status, data) => {
                    if (status) {
                      this.router.navigate(['/dashboard']);
                    }
                  })
                } else {
                  Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Errore generico'
                  });
                }
              });
            }
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'utente o password errate'
            });
          }
        } 
      });
    }
  }
}